<template>
  <div style="height: auto;width: 100%;" class="cargo-advance-search fcl-addon-search">
    <div ref="searchOperations" style="margin-top: 10px; margin-bottom: 10px;" class="cargo-advance-search-operations">
      <el-button type="primary" @click="toQuery">
        {{ $t('CargoMsg.Cargo_Query') }}
      </el-button>
      <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
      <slot name="operations">
        <!--页面操作按钮-->
      </slot>
    </div>
    <div style="width: 100%">
      <div class="section form-row">
        <el-form
          label-position="left"
          label-width="75px"
        >
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item :label="$t('Pricing.POL')">
                <cargo-advance-select
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="filter.pol"
                  @parentCallBack="p=>{filter.pol=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <div style="display: flex">
                <el-radio-group v-model="rdoGroupDes" style="margin: 5px">
                  <el-radio label="pod">{{ $t('Pricing.POD') }}</el-radio>
                  <el-radio label="rod">{{ $t('Pricing.TradeLane') }}</el-radio>
                </el-radio-group>
              </div>
            </el-col>
            <el-col :span="3">
              <cargo-advance-select
                v-show="rdoGroupDes === 'pod'"
                filterable
                :placeholder="$t('Pricing.PODPrompt2')"
                :select-type="selectTypeNames.basic_data_Seaport"
                :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                :filter-tag-names="['code','englishName']"
                :show-custom-label-in-option="true"
                :default-value="filter.pod"
                @parentCallBack="p=>{filter.pod=p.value}"
              />
              <cargo-advance-select
                v-show="rdoGroupDes === 'rod'"
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :default-value="filter.rod"
                @parentCallBack="p=>{filter.rod=p.value}"
              />
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Pricing.Source')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>item.cmpIdx===0?``:`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="filter.bookingAgent"
                  @parentCallBack="p=>{filter.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Pricing.CreatedBy')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_User"
                  :default-value="filter.createdBy"
                  :callback-params="{key:'userId'}"
                  @parentCallBack="p=>{filter.createdBy=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.BeginDate')" style="margin-left: 10px">
                <el-date-picker
                  v-model="filter.beginDate"
                  type="date"
                  style="width: 120px;"
                  value-format="yyyy-MM-dd"
                />
                <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
                <el-date-picker
                  v-model="filter.endDate"
                  type="date"
                  style="width: 120px;"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'PodChargeSearchBar',
  components: { CargoAdvanceSelect },
  props: {
    filter: {
      type: Object, default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      rdoGroupDes: 'pod'
    }
  },
  methods: {
    toQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy.pol = this.filter.pol
      this.proxy[this.rdoGroupDes] = this.filter[this.rdoGroupDes]
      this.setDateValue('beginDate', false)
      this.setDateValue('endDate', true)
      this.proxy['createdBy'] = this.filter.createdBy
      this.proxy['bookingAgent'] = this.filter.bookingAgent
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
    },
    setDateValue(field, isEnd) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field] + (isEnd ? ' 23:59:59' : '')
      }
    }
  }
}
</script>

<style lang="scss">
.fcl-addon-search{
  input.el-input__inner{
    width: 100% !important;
  }
}
</style>
